// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-reults-moviments{
  position: relative;
}

.moviment-search-results {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 400px;
  overflow: auto;
  border-radius: 6px;
  border: 1px solid var(--ui-border);
  background: var(--ui-surface);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 20;
}

.moviment-search-results  > div {
    border-radius: 0;
    padding: 6px 10px;
    background-color: #fff;
    cursor: pointer;
  }

.moviment-search-results > div + div {
  border-top: 1px solid var(--ui-border);
}

.moviment-search-result-item:hover {
  background: #f7faff;
}

.moviment-search-container {
  position: relative;
}

.moviment-search-results-internal {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--ui-border);
  background: var(--ui-surface);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 20;
  max-height: 400px;
  overflow: auto;
}

.moviment-search-results-internal  > div {
    border-radius: 0;
    padding: 6px 10px;
    background-color: #fff;
    cursor: pointer;
  }

.moviment-search-results-internal > div + div {
  border-top: 1px solid var(--ui-border);
}

.moviment-search-result-internal-item:hover {
  background: #f7faff;
}

.cadastro-visitante-button>span {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background-color: var();
}

.submit-button-moviment {
  background-color: var(--verde);
  color: #fff;
}

.selected-internals-table .remove-button {
  width: 10% !important;
  background-color: transparent;
  color: var(--Vermelho);
  margin-bottom: 10px;
  font-size: 22px;
}

.btnAdcionarVisitor{
  border: none;
  background: transparent;
  color: var(--texto-destaque);
  font-weight: 700;
  padding: 0;
  cursor: pointer;
}

.movement-results-count {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-muted);
}

.movement-search-help {
  display: block;
  margin-top: 6px;
  margin-left: 4px;
  font-size: 12px;
  color: var(--ui-muted);
}

.movement-field-label {
  display: block;
  margin: 0 0 6px 4px;
  font-size: 12px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .3px;
}

.movement-visitor-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}

.movement-visitor-status.status-liberado {
  color: #0a7a55;
  background: #dff8ee;
  border: 1px solid #b6edd9;
}

.movement-visitor-status.status-nao-liberado {
  color: #7a5b00;
  background: #fff7d8;
  border: 1px solid #efd98a;
}

.movement-visitor-status.status-bloqueado {
  color: #8f1d1d;
  background: #ffe1e1;
  border: 1px solid #f4b6b6;
}

.moviment-loading-item {
  font-style: italic;
  color: var(--ui-muted);
}

.movement-register-group {
  width: 100%;
  margin-top: 20px;
}

.movement-purpose-group {
  width: 100%;
}

.movement-register-label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  margin-bottom: 6px;
}

.movement-register-help {
  margin: 0 0 8px;
  font-size: 12px;
  color: var(--ui-muted);
}

.movement-register-upload {
  width: 100%;
  min-height: 220px;
  border: 1px dashed var(--ui-border);
  border-radius: 12px;
  background: #f8faff;
  box-shadow: var(--ui-shadow-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.movement-register-upload.webcam-active {
  align-items: stretch;
}

.movement-register-webcam {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.movement-register-webcam video {
  width: 100%;
  border-radius: 10px;
  max-height: 320px;
  object-fit: cover;
}

.movement-register-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.movement-register-actions .btn-primary {
  background-color: var(--texto-destaque);
  border: none;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
}

.movement-register-actions .btn-secondary {
  background-color: #fff;
  border: 1px solid var(--texto-destaque);
  color: var(--texto-destaque);
  padding: 8px 14px;
  border-radius: 8px;
}

.movement-register-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}

.movement-register-placeholder span {
  font-size: 13px;
  font-weight: 600;
  color: #292d32b4;
}

.movement-register-preview {
  width: 100%;
  height: 100%;
  min-height: 190px;
  object-fit: contain;
  border-radius: 10px;
  background: #fff;
}

.movement-filters-bar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  align-items: end;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  padding: 12px 14px;
  margin-bottom: 14px;
  box-shadow: var(--ui-shadow-sm);
}

.movement-filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.movement-filter-item-name {
  min-width: 0;
  grid-column: span 2;
}

.movement-filter-item label {
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .3px;
  line-height: 1;
  margin-left: 2px;
}

.movement-filter-item .filter-input,
.movement-filter-item .filter-date {
  width: 100%;
  margin: 0;
}

.movement-filter-item select.filter-date,
.movement-filter-item input.filter-date,
.movement-filter-item .filter-input {
  min-height: 40px;
  border-radius: 10px;
  border: 1px solid var(--ui-border);
  background: var(--ui-input-bg);
  padding: 8px 12px;
}

.movement-filter-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-items: end;
  justify-content: stretch;
  white-space: nowrap;
}

.movement-filter-actions .btnAdcionar {
  min-width: 0;
  width: 100%;
  min-height: 40px;
  padding: 8px 10px;
  font-size: 13px;
  gap: 6px;
  border-radius: 10px;
  justify-content: center;
  margin: 0;
}

.movement-filter-actions .btn-reset {
  background: #fff;
  color: var(--texto-destaque);
}

.movement-filter-actions .btn-apply {
  background: var(--texto-destaque);
  color: #fff;
  border-color: var(--texto-destaque);
}

.movement-filter-actions .icon {
  width: 14px;
  height: 14px;
}

.movement-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 12px;
  background: #eef2ff;
  color: #3b4a6b;
}

.movement-badge-in {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.movement-badge-out {
  background: rgba(220, 38, 38, 0.12);
  color: #b91c1c;
}

.movement-view-button {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(3, 78, 162, 0.18);
  background: rgba(3, 78, 162, 0.06);
  color: var(--texto-destaque);
  padding: 0;
}

.movement-view-button:hover {
  background: rgba(3, 78, 162, 0.12);
}

.movement-details-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 6px 4px 4px;
}

.movement-details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  background: #f8faff;
}

.movement-details-header h4 {
  margin: 4px 0 0;
  color: var(--ui-text);
}

.movement-details-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .4px;
}

.movement-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.movement-details-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--ui-border);
  background: #fff;
}

.movement-details-card span {
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
}

.movement-details-card strong {
  color: var(--ui-text);
  font-size: 14px;
}

.movement-break {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.movement-details-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.movement-details-text {
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  background: #fff;
  padding: 12px;
  min-height: 74px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 480px) {
  .movement-filter-item-name {
    grid-column: span 1;
  }
}

@media (max-width: 700px) {
  .movement-filters-bar {
    align-items: stretch;
  }

  .movement-filter-actions .btnAdcionar {
    width: 100%;
  }

  .movement-register-upload {
    min-height: 180px;
  }

  .movement-register-webcam video {
    max-height: 220px;
  }

  .movement-details-grid {
    grid-template-columns: 1fr;
  }

  .movement-details-header {
    flex-direction: column;
    align-items: stretch;
  }
}

.movement-details-actions {
  padding-top: 4px;
  border-top: 1px solid var(--ui-border);
  margin-top: 4px;
}

.btn-dar-saida {
  width: 100%;
  padding: 11px 20px;
  border-radius: 12px;
  border: 1.5px solid rgba(185, 28, 28, 0.35);
  background: rgba(220, 38, 38, 0.06);
  color: #b91c1c;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.btn-dar-saida:hover:not(:disabled) {
  background: #b91c1c;
  color: #fff;
  border-color: #b91c1c;
  box-shadow: 0 4px 14px rgba(185, 28, 28, 0.22);
}

.btn-dar-saida:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Sugestão de interno na busca manual */
.internal-suggestion-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.internal-suggestion-name {
  font-weight: 500;
  color: var(--texto-principal, #1a1a2e);
}

.internal-suggestion-cpf {
  font-size: 12px;
  color: var(--texto-secundario, #6b7280);
}

.internal-suggestion-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 4px;
}

.internal-suggestion-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(3, 78, 162, 0.08);
  color: var(--azul, #034ea2);
  border: 1px solid rgba(3, 78, 162, 0.15);
}

.movement-oab-bypass {
  border: 1px solid #f0c36d;
  background: #fff8e6;
  border-radius: 8px;
  padding: 12px;
}

.movement-oab-bypass-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-muted);
  cursor: pointer;
}

.movement-oab-bypass-label input {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Movimentacao/movimentacao.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,uCAAuC;EACvC,WAAW;AAQb;;AANE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;AAGF;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,uCAAuC;EACvC,WAAW;EACX,iBAAiB;EACjB,cAAc;AAQhB;;AANE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;AAGF;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container-reults-moviments{\n  position: relative;\n}\n\n.moviment-search-results {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 400px;\n  overflow: auto;\n  border-radius: 6px;\n  border: 1px solid var(--ui-border);\n  background: var(--ui-surface);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n\n  >div {\n    border-radius: 0;\n    padding: 6px 10px;\n    background-color: #fff;\n    cursor: pointer;\n  }\n}\n\n.moviment-search-results > div + div {\n  border-top: 1px solid var(--ui-border);\n}\n\n.moviment-search-result-item:hover {\n  background: #f7faff;\n}\n\n.moviment-search-container {\n  position: relative;\n}\n\n.moviment-search-results-internal {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid var(--ui-border);\n  background: var(--ui-surface);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n  max-height: 400px;\n  overflow: auto;\n\n  >div {\n    border-radius: 0;\n    padding: 6px 10px;\n    background-color: #fff;\n    cursor: pointer;\n  }\n}\n\n.moviment-search-results-internal > div + div {\n  border-top: 1px solid var(--ui-border);\n}\n\n.moviment-search-result-internal-item:hover {\n  background: #f7faff;\n}\n\n.cadastro-visitante-button>span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  background-color: var();\n}\n\n.submit-button-moviment {\n  background-color: var(--verde);\n  color: #fff;\n}\n\n.selected-internals-table .remove-button {\n  width: 10% !important;\n  background-color: transparent;\n  color: var(--Vermelho);\n  margin-bottom: 10px;\n  font-size: 22px;\n}\n\n.btnAdcionarVisitor{\n  border: none;\n  background: transparent;\n  color: var(--texto-destaque);\n  font-weight: 700;\n  padding: 0;\n  cursor: pointer;\n}\n\n.movement-results-count {\n  margin: 0 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ui-muted);\n}\n\n.movement-search-help {\n  display: block;\n  margin-top: 6px;\n  margin-left: 4px;\n  font-size: 12px;\n  color: var(--ui-muted);\n}\n\n.movement-field-label {\n  display: block;\n  margin: 0 0 6px 4px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .3px;\n}\n\n.movement-visitor-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.movement-visitor-status.status-liberado {\n  color: #0a7a55;\n  background: #dff8ee;\n  border: 1px solid #b6edd9;\n}\n\n.movement-visitor-status.status-nao-liberado {\n  color: #7a5b00;\n  background: #fff7d8;\n  border: 1px solid #efd98a;\n}\n\n.movement-visitor-status.status-bloqueado {\n  color: #8f1d1d;\n  background: #ffe1e1;\n  border: 1px solid #f4b6b6;\n}\n\n.moviment-loading-item {\n  font-style: italic;\n  color: var(--ui-muted);\n}\n\n.movement-register-group {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.movement-purpose-group {\n  width: 100%;\n}\n\n.movement-register-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.movement-register-help {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: var(--ui-muted);\n}\n\n.movement-register-upload {\n  width: 100%;\n  min-height: 220px;\n  border: 1px dashed var(--ui-border);\n  border-radius: 12px;\n  background: #f8faff;\n  box-shadow: var(--ui-shadow-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.movement-register-upload.webcam-active {\n  align-items: stretch;\n}\n\n.movement-register-webcam {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.movement-register-webcam video {\n  width: 100%;\n  border-radius: 10px;\n  max-height: 320px;\n  object-fit: cover;\n}\n\n.movement-register-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n\n.movement-register-actions .btn-primary {\n  background-color: var(--texto-destaque);\n  border: none;\n  color: #fff;\n  padding: 8px 14px;\n  border-radius: 8px;\n}\n\n.movement-register-actions .btn-secondary {\n  background-color: #fff;\n  border: 1px solid var(--texto-destaque);\n  color: var(--texto-destaque);\n  padding: 8px 14px;\n  border-radius: 8px;\n}\n\n.movement-register-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: center;\n}\n\n.movement-register-placeholder span {\n  font-size: 13px;\n  font-weight: 600;\n  color: #292d32b4;\n}\n\n.movement-register-preview {\n  width: 100%;\n  height: 100%;\n  min-height: 190px;\n  object-fit: contain;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.movement-filters-bar {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n  align-items: end;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.movement-filter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.movement-filter-item-name {\n  min-width: 0;\n  grid-column: span 2;\n}\n\n.movement-filter-item label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .3px;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.movement-filter-item .filter-input,\n.movement-filter-item .filter-date {\n  width: 100%;\n  margin: 0;\n}\n\n.movement-filter-item select.filter-date,\n.movement-filter-item input.filter-date,\n.movement-filter-item .filter-input {\n  min-height: 40px;\n  border-radius: 10px;\n  border: 1px solid var(--ui-border);\n  background: var(--ui-input-bg);\n  padding: 8px 12px;\n}\n\n.movement-filter-actions {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  align-items: end;\n  justify-content: stretch;\n  white-space: nowrap;\n}\n\n.movement-filter-actions .btnAdcionar {\n  min-width: 0;\n  width: 100%;\n  min-height: 40px;\n  padding: 8px 10px;\n  font-size: 13px;\n  gap: 6px;\n  border-radius: 10px;\n  justify-content: center;\n  margin: 0;\n}\n\n.movement-filter-actions .btn-reset {\n  background: #fff;\n  color: var(--texto-destaque);\n}\n\n.movement-filter-actions .btn-apply {\n  background: var(--texto-destaque);\n  color: #fff;\n  border-color: var(--texto-destaque);\n}\n\n.movement-filter-actions .icon {\n  width: 14px;\n  height: 14px;\n}\n\n.movement-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 88px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 12px;\n  background: #eef2ff;\n  color: #3b4a6b;\n}\n\n.movement-badge-in {\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n}\n\n.movement-badge-out {\n  background: rgba(220, 38, 38, 0.12);\n  color: #b91c1c;\n}\n\n.movement-view-button {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(3, 78, 162, 0.18);\n  background: rgba(3, 78, 162, 0.06);\n  color: var(--texto-destaque);\n  padding: 0;\n}\n\n.movement-view-button:hover {\n  background: rgba(3, 78, 162, 0.12);\n}\n\n.movement-details-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 6px 4px 4px;\n}\n\n.movement-details-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid var(--ui-border);\n  border-radius: 12px;\n  background: #f8faff;\n}\n\n.movement-details-header h4 {\n  margin: 4px 0 0;\n  color: var(--ui-text);\n}\n\n.movement-details-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n\n.movement-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.movement-details-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--ui-border);\n  background: #fff;\n}\n\n.movement-details-card span {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n}\n\n.movement-details-card strong {\n  color: var(--ui-text);\n  font-size: 14px;\n}\n\n.movement-break {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.movement-details-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.movement-details-text {\n  border: 1px solid var(--ui-border);\n  border-radius: 12px;\n  background: #fff;\n  padding: 12px;\n  min-height: 74px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n@media (max-width: 480px) {\n  .movement-filter-item-name {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 700px) {\n  .movement-filters-bar {\n    align-items: stretch;\n  }\n\n  .movement-filter-actions .btnAdcionar {\n    width: 100%;\n  }\n\n  .movement-register-upload {\n    min-height: 180px;\n  }\n\n  .movement-register-webcam video {\n    max-height: 220px;\n  }\n\n  .movement-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .movement-details-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.movement-details-actions {\n  padding-top: 4px;\n  border-top: 1px solid var(--ui-border);\n  margin-top: 4px;\n}\n\n.btn-dar-saida {\n  width: 100%;\n  padding: 11px 20px;\n  border-radius: 12px;\n  border: 1.5px solid rgba(185, 28, 28, 0.35);\n  background: rgba(220, 38, 38, 0.06);\n  color: #b91c1c;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.btn-dar-saida:hover:not(:disabled) {\n  background: #b91c1c;\n  color: #fff;\n  border-color: #b91c1c;\n  box-shadow: 0 4px 14px rgba(185, 28, 28, 0.22);\n}\n\n.btn-dar-saida:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Sugestão de interno na busca manual */\n.internal-suggestion-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.internal-suggestion-name {\n  font-weight: 500;\n  color: var(--texto-principal, #1a1a2e);\n}\n\n.internal-suggestion-cpf {\n  font-size: 12px;\n  color: var(--texto-secundario, #6b7280);\n}\n\n.internal-suggestion-tags {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.internal-suggestion-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(3, 78, 162, 0.08);\n  color: var(--azul, #034ea2);\n  border: 1px solid rgba(3, 78, 162, 0.15);\n}\n\n.movement-oab-bypass {\n  border: 1px solid #f0c36d;\n  background: #fff8e6;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.movement-oab-bypass-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ui-muted);\n  cursor: pointer;\n}\n\n.movement-oab-bypass-label input {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
